import React from 'react'
import { Icon } from '../icon/icon'
import { IconName } from '@/presentation/constants/icon-paths'

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger'

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant
  size?: 'sm' | 'md'
  icon?: IconName
}

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary:   'bg-green-600 text-white hover:bg-green-700',
  secondary: 'border border-border-2 text-text hover:bg-surface-2',
  ghost:     'text-text-2 hover:bg-surface-3',
  danger:    'text-red-600 border border-red-200 hover:bg-red-50',
}

export const Button: React.FC<ButtonProps> = ({
  children, variant = 'primary', size = 'md', icon, type = 'button', className = '', ...rest
}) => {
  const sizeClass = size === 'sm'
    ? 'px-3 py-1.5 text-sm gap-1.5'
    : 'px-4 py-2 text-sm gap-2'

  return (
    <button
      type={type}
      {...rest}
      className={[
        'inline-flex items-center font-medium rounded-[8px] transition-colors',
        sizeClass,
        VARIANT_CLASS[variant],
        className,
      ].join(' ')}
    >
      {icon && <Icon name={icon} size={size === 'sm' ? 15 : 17} strokeWidth={2} />}
      {children}
    </button>
  )
}
